// @flow

type CommonStates = 'idle' | 'loading_asset';
type AustinState =
  | 'Austin_connecting'
  | 'Austin_starting_streaming'
  | 'Austin_stopping_streaming'
  | 'Austin_streaming'
  | 'Austin_seeking'
  | 'Austin_paused'
  | 'Austin_error'
  | 'Austin_changing_channel'
  | 'Austin_disconnecting';

type BitmovinState =
  | 'Bitmovin_loading_stream'
  | 'Bitmovin_playing'
  | 'Bitmovin_paused'
  | 'Bitmovin_error'
  | 'Bitmovin_playback_finished';

const AUSTIN_STATES: Array<AustinState> = [
  'Austin_connecting',
  'Austin_starting_streaming',
  'Austin_stopping_streaming',
  'Austin_streaming',
  'Austin_seeking',
  'Austin_paused',
  'Austin_error',
  'Austin_changing_channel',
  'Austin_disconnecting',
];

const BITMOVIN_STATES: Array<BitmovinState> = [
  'Bitmovin_loading_stream',
  'Bitmovin_playing',
  'Bitmovin_paused',
  'Bitmovin_error',
  'Bitmovin_playback_finished',
];

export type ReceiverUiState = CommonStates | AustinState | BitmovinState;

const isIdle = (state: ReceiverUiState) => state === 'idle';

const isAustinState = (state: ReceiverUiState) => AUSTIN_STATES.includes(state);
const isBitmovinState = (state: ReceiverUiState) => BITMOVIN_STATES.includes(state);

const isAustinError = (state: ReceiverUiState) => state === 'Austin_error';
const isBitmovinError = (state: ReceiverUiState) => state === 'Bitmovin_error';
const isError = (state: ReceiverUiState) => isAustinError(state) || isBitmovinError(state);

const isBitmovinPaused = (state: ReceiverUiState) => state === 'Bitmovin_paused';
const isAustinPaused = (state: ReceiverUiState) => state === 'Austin_paused';
const isPaused = (state: ReceiverUiState) => isAustinPaused(state) || isBitmovinPaused(state);

const isAustinStreaming = (state: ReceiverUiState) => state === 'Austin_streaming';
const isBitmovinPlaying = (state: ReceiverUiState) => state === 'Bitmovin_playing';
const isPlaying = (state: ReceiverUiState) => isAustinStreaming(state) || isBitmovinPlaying(state);

const isBitmovinLoading = (state: ReceiverUiState) => state === 'Bitmovin_loading_stream';
const isLoadingAsset = (state: ReceiverUiState) =>
  state === 'loading_asset' || isBitmovinLoading(state);

export const ReceiverUiStates = {
  isIdle,
  isAustinState,
  isBitmovinState,
  isError,
  isAustinError,
  isBitmovinError,
  isPaused,
  isBitmovinPaused,
  isAustinPaused,
  isBitmovinLoading,
  isLoadingAsset,
  isAustinStreaming,
  isBitmovinPlaying,
  isPlaying,
};
